import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["overrides", "variantOverrides", "variantFieldConfigs", "fieldConfigs"];
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { convertChirpFieldOverridesToJson } from 'ContentData/utils/chirp';
import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
import { getBufferByThemeRpc } from '../../__generated__/chirp/com/hubspot/global/styles/rpc/GlobalStylesRpc';
import { getBufferedActiveThemeRpc, getByIdRpc as getThemeByIdRpc } from '../../__generated__/chirp/com/hubspot/global/styles/rpc/ThemeRpc';
import PortalIdParser from 'PortalIdParser';
import { convertBindingsToJackson, convertFieldConfigsToJackson, convertOverridesToJackson, convertVariantDataToJackson } from '../utils/globalStyles';
export function fetchGlobalStylesFields(...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('global/styles/v1/fields');
}
export async function fetchGlobalStylesObject(httpClient = http) {
  const rpcClient = createRpcClientV2({
    hubHttpClient: httpClient
  });
  const theme = await rpcClient.call(getBufferedActiveThemeRpc, {
    request: {}
  });
  const {
    themeId,
    overrides
  } = await rpcClient.call(getBufferByThemeRpc, {
    request: {
      themeId: theme.id
    }
  });
  return {
    themeId,
    overrides: convertChirpFieldOverridesToJson(overrides !== null && overrides !== void 0 ? overrides : {})
  };
}
export async function fetchThemePreset(presetId, httpClient = http) {
  const rpcClient = createRpcClientV2({
    hubHttpClient: httpClient
  });
  const {
    styles
  } = await rpcClient.call(getThemeByIdRpc, {
    request: {
      id: presetId
    }
  });
  return convertChirpFieldOverridesToJson(styles !== null && styles !== void 0 ? styles : {});
}
export function fetchGlobalStylesCss({
  globalStyles,
  bufferTheme,
  cssWrapperSelector
} = {}) {
  const data = {};
  if (!bufferTheme && globalStyles) {
    const {
        overrides,
        variantOverrides,
        variantFieldConfigs,
        fieldConfigs
      } = globalStyles,
      rest = _objectWithoutPropertiesLoose(globalStyles, _excluded);
    data.globalStyles = Object.assign({}, rest, {
      overrides: convertOverridesToJackson(overrides),
      fieldConfigs: convertFieldConfigsToJackson(fieldConfigs),
      variantOverrides: convertVariantDataToJackson(variantOverrides),
      variantFieldConfigs: convertBindingsToJackson(variantFieldConfigs),
      portalId: PortalIdParser.get()
    });
  }
  if (cssWrapperSelector) {
    data.cssWrapperSelector = cssWrapperSelector;
  }
  return http.post('global-styles-rendering/v1/css', {
    query: {
      bufferTheme
    },
    data
  });
}
export const GET_CSS_VARS = registerQuery({
  fieldName: 'cssVars',
  args: ['globalStyles', 'bufferTheme', 'cssWrapperSelector'],
  fetcher: fetchGlobalStylesCss
});